var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCFlatSeatFrontRow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#19568e",
  d: "M0 28V5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v23z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e3152",
  d: "M0 24h23.98v4H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12.47 4.56 1.66 4.58h5.34L15.15 12l1.65 4.58-4.33-2.83-4.32 2.81L9.8 12 5.47 9.15h5.35z"
})));
export { SvgCFlatSeatFrontRow as ReactComponent };